<img src="assets/images/warning-graphic.svg" alt="Warning">

<p><b>404</b> Page not Found</p>

<a class="button" [routerLink]="['/']" mat-ripple>Go Home</a>

<ngx-sw-update-button [class.ghost]="!swService.enabled"></ngx-sw-update-button>
